import { HospitalBoxOutlineIcon } from './HospitalBoxOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 2D50B6E0-C01B-4EDE-BA85-A14757A27D54
 * name hospital-box-outline
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hospital-box-outline.svg
 * tags
 * - Medical / Hospital 
 */
export const DispensaryBoxOutlineIcon = HospitalBoxOutlineIcon;
export default DispensaryBoxOutlineIcon